import { Component, OnInit } from '@angular/core';
import { BaseComponent } from "@bt/core/base";
import { NotifierService } from "angular-notifier";
import { UserBalanceModel, FinanceService, PaymentModel, UserService} from "@bt/core";
import { faPlus, faTimes, faCheck } from '@fortawesome/free-solid-svg-icons';
import { NgbModal,NgbActiveModal,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { ConfirmModalContent } from './confirm-modal';
import { FormGroup, FormBuilder, Validators, FormsModule,FormArray } from "@angular/forms";

@Component({
  selector: 'app-finance',
  templateUrl: './finance.component.html',
  styleUrls: ['./finance.component.scss']
})
export class FinanceComponent extends BaseComponent implements OnInit {

  faPlus = faPlus;
  faTimes = faTimes;
  faCheck = faCheck;

  public payments: any = [];
  public userBalance: UserBalanceModel;
  public newPayment: PaymentModel;
  notifier: any;
  public modalRef: NgbModalRef;
  public paymentValidForm: FormGroup;

  constructor(
    notifierService: NotifierService,
    private financeService: FinanceService,
    private userService: UserService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    ) {
    super();
    this.notifier = notifierService;

   }

  ngOnInit() {
    this.paymentValidForm = this.fb.group({
      paymentForm:     ["", [Validators.required, Validators.min(1), Validators.max(99999), Validators.pattern(this.onlyNumPattern)]],
    });

    this.userBalance = new UserBalanceModel();
    this.newPayment = new PaymentModel();
    this.GetUserBalanse();
    this.GetUserPayments();
  }

  get paymentForm() { return this.paymentValidForm.get('paymentForm'); }

  GetUserBalanse(){
    this.setLoading(true);
    this.financeService.GetUserBalance()
    .then((resp) => {
      resp.data == null ? this.userBalance.balance = 0 : this.userBalance = resp.data;
      this.setLoading(false);
    })
    .catch((error)=>{
      this.notifier.notify('error', "Ошибка при получении баланса");
      this.setLoading(false);
    });
  }

  GetUserPayments(){
    this.setLoading(true);
    this.financeService.GetUserPayments()
    .then((resp) => {
      this.payments = resp.data;
      this.payments.forEach(payMent => {
        payMent.createdAt = payMent.createdAt.substring(0, 10);
      });
      this.setLoading(false);
    })
    .catch((error)=>{
      this.notifier.notify('error', "Ошибка при получении списка выплат");
      this.setLoading(false);
    });
  }

  AddNewUserPayment(newPayment : PaymentModel){
    this.setLoading(true);
    if (!this.paymentValidForm.valid) {
      this.setLoading(false);
      this.notifier.notify('error', "Недопустимое значение суммы выплаты");
      this.markFormGroupTouchedAndDirty(this.paymentValidForm);
      return;
    }
    newPayment.status = 0;
    this.financeService.AddNewUserPayment(newPayment)
    .then((resp) => {
      this.setLoading(false);
      this.ngOnInit();
    })
    .catch((error)=>{
      this.notifier.notify('error', "Ошибка при запросе выплаты");
      this.setLoading(false);
    });
  }

  statusOutput(payment: PaymentModel){
    var output = "";
    payment.status == 0 ?  output = ("Запрошено") :
    payment.status == 1 ?  output = ("Одобрено") :
    payment.status == 2 ?  output = ("Отклонено") :
    payment.status == 3 ?  output = ("Выплачего") :
    payment.status == 4 ?  output = ("Ошибка") : output = ("please fix me ☺");
    return output;
  }

  public getRole():number {
		return this.userService.getRole();
  }
  
  openCanceledPayment(paymentToCanceled: PaymentModel){
    let t=this;
    t.modalRef = t.modalService.open(ConfirmModalContent,
      {
        backdropClass: 'light-white-backdrop',
        centered: true ,
        size: 'sm',
        windowClass:'super-modal-delete-users very-nice-shadow',

      });
      t.modalRef.componentInstance.isNeedDelete=false;
      t.modalRef.componentInstance.description="Вы действительно хотите отменить выплату?";
      t.modalRef.componentInstance.title="Отклонить выплату";
      t.modalRef.componentInstance.btnText="Отклонить";
      t.modalRef
      .result.then((result)=>{
        if(result){

          t.financeService.CanceledPayment(paymentToCanceled.id)
          .then((resp) => {
            if (resp.data == true) {
              t.notifier.notify('success', "Успешно отклонено");
              t.GetUserPayments();
            }
          })
          .catch((error) => {
        //console.error(error.error);
          });
        }


      },
      (reason) => {
        //если отменили нажали на крестик или мимо окна
      })
  }

  openApprovedPayment(paymentToApproved: PaymentModel){
    let t=this;
    t.modalRef = t.modalService.open(ConfirmModalContent,
      {
        backdropClass: 'light-white-backdrop',
        centered: true ,
        size: 'sm',
        windowClass:'super-modal-delete-users very-nice-shadow',

      });
      t.modalRef.componentInstance.isNeedDelete=false;
      t.modalRef.componentInstance.description="Вы действительно хотите одобрить выплату?";
      t.modalRef.componentInstance.title="Одобрить выплату";
      t.modalRef.componentInstance.btnText="Одобрить";
      t.modalRef
      .result.then((result)=>{
        if(result){
          t.financeService.ApprovedPayment(paymentToApproved.id)
          .then((resp) => {
            if (resp.data == true) {
              t.notifier.notify('success', "Успешно одобрено");
              t.GetUserPayments();
            }
          })
          .catch((error) => {
        //console.error(error.error);
          });
        }


      },
      (reason) => {
        //если отменили нажали на крестик или мимо окна
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/finance/finance.component.ts